import { render, staticRenderFns } from "./d2-container-card.vue?vue&type=template&id=ae877d8a&"
import script from "./d2-container-card.vue?vue&type=script&lang=js&"
export * from "./d2-container-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "d2-container-card.vue"
export default component.exports